import { render, staticRenderFns } from "./StormBookTag.vue?vue&type=template&id=a86fa898&scoped=true&"
import script from "./StormBookTag.vue?vue&type=script&lang=js&"
export * from "./StormBookTag.vue?vue&type=script&lang=js&"
import style0 from "./StormBookTag.vue?vue&type=style&index=0&id=a86fa898&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86fa898",
  null
  
)

export default component.exports